var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1.66797 10.7334V9.26669C1.66797 8.40003 2.3763 7.68336 3.2513 7.68336C4.75964 7.68336 5.3763 6.6167 4.61797 5.30836C4.18464 4.55836 4.44297 3.58336 5.2013 3.15003L6.64297 2.32503C7.3013 1.93336 8.1513 2.1667 8.54297 2.82503L8.63463 2.98336C9.38463 4.2917 10.618 4.2917 11.3763 2.98336L11.468 2.82503C11.8596 2.1667 12.7096 1.93336 13.368 2.32503L14.8096 3.15003C15.568 3.58336 15.8263 4.55836 15.393 5.30836C14.6346 6.6167 15.2513 7.68336 16.7596 7.68336C17.6263 7.68336 18.343 8.39169 18.343 9.26669V10.7334C18.343 11.6 17.6346 12.3167 16.7596 12.3167C15.2513 12.3167 14.6346 13.3834 15.393 14.6917C15.8263 15.45 15.568 16.4167 14.8096 16.85L13.368 17.675C12.7096 18.0667 11.8596 17.8334 11.468 17.175L11.3763 17.0167C10.6263 15.7084 9.39297 15.7084 8.63463 17.0167L8.54297 17.175C8.1513 17.8334 7.3013 18.0667 6.64297 17.675L5.2013 16.85C4.44297 16.4167 4.18464 15.4417 4.61797 14.6917C5.3763 13.3834 4.75964 12.3167 3.2513 12.3167C2.3763 12.3167 1.66797 11.6 1.66797 10.7334Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0013 12.7084C11.4971 12.7084 12.7096 11.4959 12.7096 10.0001C12.7096 8.50431 11.4971 7.29175 10.0013 7.29175C8.50553 7.29175 7.29297 8.50431 7.29297 10.0001C7.29297 11.4959 8.50553 12.7084 10.0013 12.7084Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.5ff5f3eeaa42e5ebc6dbbc0c5950b867.svg";
export { ForwardRef as ReactComponent };